export enum EOrigemNotaFiscalServico
{
    NotaFiscalServico = 1,
    EmissaoPeloFinanceiro = 2,
    NotaContraCnpj = 3,
}
